import clsx from 'clsx';
import React from 'react';
import { Container } from 'react-bootstrap';

import {
  CORPORATE_SUBSCRIPTION_FORM_URL,
  MEDIA_KIT_URL,
  PARTNERSHIP_FORM_URL,
  PARTNERSHIP_IMAGE_URL,
} from '../../utils/constants';
import { Button } from '../BaseUI';
import styles from './styles.module.scss';

const PartnershipOpportunitiesSection = () => {
  return (
    <div id="partnerships" className={styles.partnershipBackground}>
      <Container>
        <div className={styles.partnershipContainer}>
          <h5 className={styles.partnershipTitle}>Partnership Opportunities</h5>
          <h1 className={styles.partnershipSubTitle}>Why The Information</h1>
          <div className={styles.partnershipContent}>
            {/* Note: Any copy changes below will also need to be made in app/controllers/api/snippets_controller.rb */}
            The Information is one of the most trusted and heavily cited publications covering the
            technology industry. For nearly a decade we have broken many of the most important
            stories in the industry - often years before other publications catch on. We arguably
            have the largest engaged subscriber base of startup founders, venture capitalists, and
            technology decision makers in the world. There are several ways we work with corporate
            partners including:
            <p className={styles.bulletPoint}>
              <span className={styles.bulletTitle}>- Corporate Subscriptions:</span> empower your
              team with deep industry knowledge & the ability to engage on our platform with other
              subscribers.{' '}
              <Button
                className={styles.bulletLink}
                href={CORPORATE_SUBSCRIPTION_FORM_URL}
                trackClick
                trackingProps={{
                  name: 'corporate_subscription_form',
                  location: 'partnership_opportunities',
                }}
                variant="link"
              >
                Learn more about corporate subscriptions.
              </Button>
            </p>
            <p className={styles.bulletPoint}>
              <span className={styles.bulletTitle}>- Corporate Partnerships:</span> for select
              partners that want their brand and message in front of our community & associated with
              true quality independent journalism.
            </p>
          </div>
          <Button
            href={PARTNERSHIP_FORM_URL}
            className={clsx(styles.button, styles.blackButton)}
            rounded="slight"
            trackClick
            trackingProps={{
              name: 'partnership_form',
              location: 'partnership_opportunities',
            }}
          >
            CONTACT US ABOUT PARTNERSHIP OPPORTUNITIES
          </Button>
          <Button
            href={MEDIA_KIT_URL}
            trackClick
            trackingProps={{
              name: 'media_kit',
              location: 'partnership_opportunities',
            }}
            variant="link"
          >
            VIEW MEDIA KIT
          </Button>
        </div>
        <img src={PARTNERSHIP_IMAGE_URL} className={styles.partnershipImage} />
      </Container>
    </div>
  );
};
export default PartnershipOpportunitiesSection;
